import { message, notification } from 'ant-design-vue';
import router from '../router'
import store from '../store'


let lockReconnect = false//避免ws重复连接
let isReconnect = true //是否重连
let ws = null // 判断当前浏览器是否支持WebSocket

let webSocketUrl = localStorage.getItem("webSocketUrl")
let wsUrl = webSocketUrl || ""

let msgCount = localStorage.getItem("msgCount") || 0

function createWebSocket(wsUrl) {
	try {
		// if(typeof(WebSocket) === "undefined"){
		// 	alert("您的浏览器不支持socket")
		// }else{
		// 	// 实例化socket
		// 	this.socket = new WebSocket(url);
		// }
		if ('WebSocket' in window) {
			ws = new WebSocket(wsUrl);
		} else if ('MozWebSocket' in window) {
			ws = new MozWebSocket(wsUrl);
		} else {
			// message.error('您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！')
			console.log('您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！')
		}
		initEventHandle();
	} catch (e) {
		if (isReconnect) {
			reconnect(wsUrl);
		}
		console.log(e);
	}
}

function initEventHandle() {
	ws.onclose = function () {
		console.log("连接关闭!" + new Date().toLocaleTimeString());
		if (isReconnect) {
			reconnect(wsUrl);
		}
	};
	ws.onerror = function () {
		// message.error('网络连接错误，请重新登录！')
		websocketClose();//主动关闭连接
		// router.push("/login");
		console.log("连接错误!" + new Date().toLocaleTimeString());
		if (isReconnect) {
			reconnect(wsUrl);
		}
	};
	ws.onopen = function () {
		heartCheck.reset().start(); //心跳检测重置
		if (localStorage.getItem("USER")) {
			sendSock("SHIOT|REG|" + JSON.parse(localStorage.getItem("USER")).userId);
		}
		console.log("连接成功!" + new Date().toLocaleTimeString());
	};
	ws.onmessage = function (event) { //如果获取到消息，心跳检测重置
		heartCheck.reset().start(); //拿到任何消息都说明当前连接是正常的
		let dataStr = event.data
		console.log("收到消息啦:" + dataStr)
		handMsg(isJSON(dataStr) ? dataStr : JSON.stringify(dataStr));
	};
}

function isJSON(str) {
	if (typeof str == 'string') {
		try {
			var obj=JSON.parse(str);
			if(typeof obj == 'object' && obj ){
				return true;
			}else{
				return false;
			}

		} catch(e) {
			console.log('error：'+str+'!!!'+e);
			return false;
		}
	}
	console.log('It is not a string!')
}

// 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
window.onbeforeunload = function () {
	ws.close();
}

//刷新页面后需要重连
if (window.performance.navigation.type == 1 && localStorage.getItem("USER")) {
	if (isReconnect) {
		reconnect(wsUrl);
	}
}

//重连
function reconnect(wsUrl) {
	if (lockReconnect) return;
	lockReconnect = true;
	setTimeout(function () { //没连接上会一直重连，设置延迟避免请求过多
		createWebSocket(wsUrl);
		lockReconnect = false;
	}, 2000);
}

//心跳检测
var heartCheck = {
	//timeout: 540000,        //9分钟发一次心跳
	timeout: 3600, //1分钟发一次心跳
	// timeout: 10800, //3分钟发一次心跳
	timeoutObj: null,
	serverTimeoutObj: null,
	reset: function () {
		clearTimeout(this.timeoutObj);
		clearTimeout(this.serverTimeoutObj);
		return this;
	},
	start: function () {
		var self = this;
		this.timeoutObj = setTimeout(function () {
			self.serverTimeoutObj = setTimeout(function () {
				//如果超过一定时间还没重置，说明后端主动断开了
				//如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
				// ws.close();
			}, self.timeout)
		}, this.timeout)
	}
}

// 实际调用的方法
function sendSock(agentData, callback) {
	// global_callback = callback;
	if (ws.readyState === ws.OPEN) {
		//若是ws开启状态
		websocketSend(agentData)
	} else if (ws.readyState === ws.CONNECTING) {
		// 若是 正在开启状态，则等待1s后重新调用
		setTimeout(function () {
			sendSock(agentData, callback);
		}, 1000);
	} else {
		// 若未开启 ，则等待1s后重新调用
		setTimeout(function () {
			sendSock(agentData, callback);
		}, 1000);
	}
}

//数据发送
function websocketSend(agentData) {
	ws.send(agentData);
}

//主动关闭连接
function websocketClose() {
	console.log("主动关闭连接!");
	isReconnect = false
	ws.close()
	ws = null
	lockReconnect = false
	localStorage.clear();
}

//处理消息
function handMsg(dataStr) {
	if (!dataStr) {
		return
	}
	let data = JSON.parse(dataStr)
	if(!data instanceof Object){
		return
	}
	switch (data.code) {
		case 1:
			msgCount = Number(data.data)
			store.commit('update', ['msgCount', msgCount])
			localStorage.setItem("msgCount", msgCount);
			const key = `open${Date.now()}`;
			notification.open({
				message: data.title,
				description: data.message,
				placement: 'bottomRight',
				btn: h => {
					return h(
						'a-button',
						{
							props: {
								type: 'primary',
								size: 'small',
							},
							on: {
								click: () => {
									notification.close(key)
									router.push("/noticeList")
								}
							},
						},
						'查看消息',
					);
				},
				key,
				onClose: close,
			});
			break;
		case 2:
			msgCount = Number(data.data)
			store.commit('update', ['msgCount', msgCount])
			localStorage.setItem("msgCount", msgCount);
			break
	}
}

const socketApi = {
	msgCount,
	sendSock,
	websocketClose,
	createWebSocket
}

export default socketApi



// WEBPACK FOOTER //
// ./src/utils/webSocket.js